import { render, staticRenderFns } from "./CommentsLayout.vue?vue&type=template&id=8eab606a&scoped=true&"
import script from "./CommentsLayout.vue?vue&type=script&lang=js&"
export * from "./CommentsLayout.vue?vue&type=script&lang=js&"
import style0 from "./CommentsLayout.vue?vue&type=style&index=0&id=8eab606a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eab606a",
  null
  
)

export default component.exports